module.exports = __webpack_public_path__ + "static/assets/30ddd0cacd3eff34c45f1107fcc811e6.svg";